import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { pageTitleDecorator } from 'Decorators';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

@pageTitleDecorator('forbidden')
export default class Forbidden extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        history: PropTypes.any,
    };

    goBack = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="container-fluid error-page-container">
                <div className="outside-logo outside-centered-logo login-page-logo">
                    <a href="/">
                        <div className="outside-logo-image"></div>
                        <div className="outside-logo-text"></div>
                    </a>
                </div>
                <section className="error-page">
                    <h1><FormattedMessage id='error_page.header.forbidden' /></h1>
                    <h5><FormattedMessage id="title.forbidden" /></h5>
                    <p>
                        &laquo;
                        <a onClick={this.goBack} href="javascript:void(0);" className="d-inline-block mr-2">
                            <FormattedMessage id="error_page.link_back" />
                        </a>
                        /
                        <Link to="/" className="d-inline-block ml-2">
                            <FormattedMessage id="error_page.link_home" />
                        </Link>
                        &raquo;
                    </p>
                </section>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Forbidden/Forbidden.jsx